import {ParsedToken} from "../../auth/types";
import React, {useContext, useEffect} from "react";
import {RocketChatLoginResponse} from "./types";
import {ChatTokenContext} from "../context/chat-token-context";

export const useChatToken = (rocketChatAuthUrl: string, user?: ParsedToken, accessToken?: string): {chatToken?: string, userId?: string} => {
  const {chatToken, setChatToken, userId, setUserId} = useContext(ChatTokenContext)

  useEffect(() => {
    if (accessToken && ! chatToken) {
      fetch(rocketChatAuthUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          serviceName: 'keycloak',
          accessToken,
          expiresIn: 200,
        }),
      })
        .then(async (r): Promise<RocketChatLoginResponse> => await r.json())
        .then(r => {
          const token = r.data.authToken
          const userId = r.data.userId
          if (!! token) {
            setChatToken(token)
          }
          if (!! userId) {
            setUserId(userId)
          }
        })
        .catch(e => console.error(e))
    }
  }, [ user, accessToken, chatToken ])

  return {chatToken, userId}
}